import React from "react";

// Gatsby
import { Link } from "gatsby";
import { AnchorLink } from "gatsby-plugin-anchor-links";

// Components
import OutsideLink from "./outside-link";
import SocialIcons from "./social-icons";

// Assets
import Logo from "../images/logo.png";
import { FaPhone, FaEnvelope } from "react-icons/fa";

const routes = [
  {
    route: `/#services`,
    title: `Servicios`,
  },
  {
    route: `/research`,
    title: `Investigación`,
  },
  {
    route: `/blog`,
    title: `Blog`,
  },
  {
    route: `/equipments`,
    title: `Equipos`,
  },
  // {
  //   route: `/contact`,
  //   title: `Cursos`,
  // },
];

function Header() {
  return (
    <header className="flex flex-1 flex-col bg-seethrough_white absolute inset-x-0 z-10">
      {/* Upper row */}
      <div className="flex flex-col flex-1 md:flex-row md:h-16 items-center md:justify-start pt-3 md:pt-0 px-4 md:px-32">
        {/* Logo */}
        <Link
          to={'/'}>
          <img src={Logo} className="object-cover self-center w-48 h-auto md:h-auto md:h-16 md:mr-5 mt-2" alt="Logo Unimel" />
        </Link>
        {/* Info */}
        <div className="flex flex-col flex-1 md:flex-row h-full items-center justify-between p-0 m-0">
          <div className="flex flex-row flex-1 flex-wrap items-center lg:justify-end justify-center h-full">
            <OutsideLink icon={<FaEnvelope />} text="unimelcitas@gmail.com" route="mailto:unimelcitas@gmail.com" />
            <OutsideLink icon={<FaPhone />} text="+58 414-3186789" route="tel:+58-0414-318-6789" target="_self" />
          </div>
          {/* Social icons */}
          <SocialIcons />
        </div>
      </div>

      {/* Lower row */}
      <div className="flex flex-1 flex-col md:flex-row flex-wrap items-center py-4 px-4 md:px-32 border-t">
        {/* Site navigation */}
        <nav className="flex flex-row flex-1 md:flex-0">
          {routes.map(({ title, route }, i) => (
            <Link
              className={`block text-gray-900 font-medium hover:text-gray-700 mx-2 md:mx-0 no-underline md:inline-block md:mt-0 ${i > 0 ? 'md:ml-8' : ''}`}
              key={title}
              to={route}>
              {title}
            </Link>
          ))}
        </nav>
        <div className="flex flex-1 mt-4 md:mt-0 justify-center md:justify-end">
          <AnchorLink
            className="text-sm bg-main_color hover:bg-white hover:text-main_color text-white no-underline py-4 px-10 rounded-md"
            to='/contact'>
            RESERVAR UNA CITA
          </AnchorLink>
        </div>
      </div>
    </header>
  );
}

export default Header;
